import React, { useEffect, useState, useRef } from 'react';
import { TransitionGroup, Transition as ReactTransition } from 'react-transition-group';
import getTransitionStyle from '../helpers/getTransitionStyle';

const Transition = (props) => {
  const { children, location } = props;
  const [ duration, setDuration ] = useState(300);
  const nodeRef = useRef(null);

  // useEffect(() => {
  //   if (location.pathname.indexOf('/games/lifecycle') > -1 || location.pathname.indexOf('/news') > -1) {
  //     setDuration(0);
  //   }
  // }, []);

  return (
    <TransitionGroup>
      <ReactTransition
        nodeRef={nodeRef}
        appear
        key={location.pathname}
        timeout={{
          enter: duration,
          exit: duration
        }}
      >
        {(status) => {
          return (
            <div
              ref={nodeRef}
              style={
                {
                  ...getTransitionStyle({
                    status: status,
                    timeout: duration,
                  }),
                }
              }
              className={
                `fade fade-${status}`
              }
            >
              {children}
            </div>
          );
        }}
      </ReactTransition>
    </TransitionGroup>
  );
}

export default Transition;
